import { Link, useNavigate } from "react-router-dom";
import BookingType from "../../../api/enums/BookingType";
import Gender from "../../../api/enums/Gender";
import { HostChatMessage, PartyModel } from "../../../types";
import { iconsImgs } from "../../../utils/icons";
import { routes } from "../../../routes/routes";
import { getUserAvatar } from "../../../utils/getMedia";
import { ReactEventHandler, useContext } from "react";
import { SelectedGroupContext } from "../../../GlobalContext/groupDetailContext";
import { formateDateForPromoterGroups } from "../../../utils/datePareser";
import { localStorageKeys } from "../../../utils/localStorageKeys";
import GetHostChatMessages from "../../../api/GetHostChatMessagesApi";
import AuthClient from "../../../api/AuthClient";

interface Props {
    group: PartyModel;
}

const AcceptedGroupDetail: React.FC<Props> = ({ group }) => {

    const authClient = new AuthClient();
    const navigate = useNavigate();
    const userImg = localStorage.getItem(localStorageKeys.userImg) || "";

    const { setSelectedGroup } = useContext(SelectedGroupContext);
    const handleClickInvitation = (selectedGroup: PartyModel) => {
        if (selectedGroup) {
            setSelectedGroup(selectedGroup);
        }
    };

    const selectedPromoterOffer = group.promotersOffers.find((promoterOffer) =>
        promoterOffer.offers.some((offer) => offer.isAccepted === true)
    );
    const acceptedOffer = selectedPromoterOffer?.offers.find(
        (offer) => offer.isAccepted === true
    );

    const openChats = (partyGroup: PartyModel) => {

        const selectedPromoterOffer = partyGroup.promotersOffers.find((promoterOffer) =>
            promoterOffer.offers.some((offer) => offer.isAccepted === true)
        );
        const acceptedOffer = selectedPromoterOffer?.offers.find(
            (offer) => offer.isAccepted === true
        );
        const groupAdminInvitation = partyGroup.invitations.find((invitation) => invitation.isGroupAdmin) ?? partyGroup.invitations[0];

        const hostChatMessages = new GetHostChatMessages(authClient);

        if (acceptedOffer?.id) hostChatMessages.getChatMessages(acceptedOffer.id).then((response) => {

            if (response.data) {
                const messages: HostChatMessage[] | undefined = response.data;

                if (Object.keys(acceptedOffer).length > 0) {

                    acceptedOffer.partyDate = partyGroup.party.partyDate;
                }
                navigate(routes.ChatPages, {
                    state: {
                        messages: messages, 
                        offer: acceptedOffer, 
                        groupAdminName: `${groupAdminInvitation?.firstName ?? ""} ${groupAdminInvitation?.lastName ?? ""}`.trim(),
                        groupAdminId: groupAdminInvitation?.id,
                        promoterName: selectedPromoterOffer?.promoter.FirstName,
                        promoterId: selectedPromoterOffer?.promoter.id,
                        currentUserId: selectedPromoterOffer?.promoter.id,
                        returnTo: `${routes.PromotersMode}?tab=accepted`,
                    }
                });
            }
        });
    }
    const handleImgError: ReactEventHandler<HTMLImageElement> = (event) => {
        const imgElement = event.target as HTMLImageElement;
        imgElement.src = userImg;
    };

    return (
        <>
            <div className="groupPromoter mb-3">
                <div className="desktopUI">

                    {/*Date of the Accepted group and ClubName*/}
                    <div className="datePm  d-flex align-items-center w-100">
                        <p> {formateDateForPromoterGroups(group.party.partyDate)} </p>
                        <p className="ms-5 fw-300">
                            {acceptedOffer?.clubName}
                        </p>
                    </div>

                    {/* Column Section */}
                    <div className=" text-center row align-items-start">
                        <div className=" greyBorder align-content-center justify-content-center   col">
                            <div>
                                <p className="m-0">{group.invitations[0]?.firstName}</p>
                            </div>

                            <div className="d-flex justify-content-center">
                                <p className="m-0 yellowTxt">
                                    {
                                        group.invitations.filter(
                                            (invitation) =>
                                                Gender[invitation.gender].toString() ===
                                                Gender.Female.toString()
                                        ).length
                                    }
                                </p>
                                <img
                                    src={iconsImgs.Female}
                                    alt="female icon"
                                    className=" Icons"
                                />
                                <p className="yellowTxt m-0">
                                    {
                                        group.invitations.filter(
                                            (invitation) =>
                                                Gender[invitation.gender].toString() ===
                                                Gender.Male.toString()
                                        ).length
                                    }
                                </p>
                                <img src={iconsImgs.Male} alt="male icon" className=" Icons" />
                            </div>
                        </div>

                        <div className="greyBorder col">
                            {(() => {
                                switch (group.party.bookingType.toString()) {
                                    case BookingType[BookingType.GuestList]:
                                        return (
                                            <p className="guestList">Guest List</p>
                                        );

                                    case BookingType[BookingType.TableBooking]:
                                        return (
                                            <>
                                                <p className="m-0">Table</p>
                                                <p className="m-0 yellowTxt">{group.promotersOffers[0].offers[0].minSpend}</p>
                                            </>
                                        );
                                }
                            })()
                            }
                        </div>

                        <div className="greyBorder align-content-center justify-content-center d-flex col">
                            <img
                                src={iconsImgs.FreeDrinks}
                                alt="free drinks"
                                className="Icons AcceptedIcons"
                            />
                            <img
                                src={iconsImgs.FreeEntry}
                                alt="free entry"
                                className="Icons AcceptedIcons"
                            />
                        </div>
                    </div>

                    {/* Guest Pictures Section */}
                    <div className="promoter-avatar-row">
                        {group.invitations.map((invitation) => (
                            <Link to={routes.PromGroupDetailPage(group.party.city, group.party.id)}
                                key={invitation.id}
                                onClick={() => handleClickInvitation(group)}
                                className="promoter-avatar-row__link"
                            >
                                <img
                                    src={getUserAvatar(invitation?.id!)}
                                    alt="Profile Image"
                                    className="imgGuestA promoter-avatar-row__image"
                                    onError={(event) => { handleImgError(event) }}
                                />
                            </Link>
                        ))}
                    </div>

                    <div className="chatPreview m-1 row align-items-center">
                        {/* Clubbable Messages Preview */}
                        <div className="col-8 mt-2">
                            <div className="yellowTxt text-start ms-2">
                                {group.hostChatMessages.slice(-3).map((message, index) => (
                                    <p key={index} className="yellowTxt mb-0">
                                        {message.senderName}: {message.message}
                                    </p>
                                ))}
                            </div>
                        </div>

                        {/* Open Chat Button */}
                        <div className="col-4 d-flex justify-content-end">
                            <button className="chatButton" onClick={() => { openChats(group) }}>Open Chat</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AcceptedGroupDetail;
